import { Box, Select as MUISelect } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { gray } from "configs/colors";

import { generateFormFieldStyles } from "../helpers";

export const Container = styled(Box)(() => ({
  display: "block",

  // Input Label
  "& > .MuiFormLabel-root": {
    marginBottom: "6px",
  },

  // Helper text
  ".MuiFormHelperText-root": {
    marginTop: "6px",
    "&, &.Mui-disabled": {
      color: gray[600],
    },
  },
}));

export const SelectedIconWrapper = styled(Box)(() => ({
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "8px",
  marginRight: "2px",

  ".MuiSelect-select &": {
    display: "none",
  },
}));

export const StylesSelect = styled(MUISelect)(({ theme, color, value }) => {
  const styles = generateFormFieldStyles({ theme, color });
  const isEmpty = !value || (value as Array<unknown>).length === 0;

  return {
    boxShadow: styles.normal.boxShadow,
    backgroundColor: styles.normal.backgroundColor,
    borderRadius: theme.shape.borderRadius,

    // Input
    ".MuiInputBase-input": {
      padding: "8px 14px",
      height: "20px !important",
    },

    // Fieldset
    ".MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px !important",
      borderColor: styles.normal.borderColor,
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
    },

    // // Select value & placholder
    ".MuiSelect-select": {
      color: alpha(theme.palette.text.primary, isEmpty ? 0.42 : 1),
      minHeight: "20px !important",
    },

    // Select icon
    ".MuiSelect-icon": {
      color: gray[500],
    },

    // Disable
    "&.Mui-disabled": {
      "& .MuiInputBase-input": {
        backgroundColor: styles.disabled.backgroundColor,
        "-webkit-text-fill-color": alpha(
          styles.disabled.color,
          isEmpty ? 0.42 : 1
        ),
      },

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: `${styles.disabled.borderColor} !important`,
      },
    },

    // Without error
    "&:not(.Mui-error)": {
      // Hover
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.normal.hover.borderColor,
      },
      // Focus
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.normal.focus.borderColor,
        boxShadow: styles.normal.focus.boxShadow,
      },
    },

    // Error
    "&.Mui-error": {
      // Hover
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.error.hover.borderColor,
      },
      // Focus
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.error.focus.borderColor,
        boxShadow: styles.error.focus.boxShadow,
      },
    },
  };
});
